module.exports = __webpack_public_path__ + "img/logoMin.f5eeb52a.png";